import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons/faAngleDoubleRight";
import { faAngleDoubleLeft } from "@fortawesome/free-solid-svg-icons/faAngleDoubleLeft";

@Component({
  selector: "app-table-header",
  templateUrl: "./table-header.component.html",
  styleUrls: ["./table-header.component.scss"]
})
export class TableHeaderComponent implements OnInit {
  public faSearch = faSearch;
  public faAngleDoubleRight = faAngleDoubleRight;
  public faAngleDoubleLeft = faAngleDoubleLeft;

  @Input() pageIndex: number;
  @Output() pageIndexChange: EventEmitter<number>;

  @Input() pageCount: number | null;
  @Input() error: string | null;
  @Input() loading: boolean;

  @Input() filter: string;
  @Output() filterChange: EventEmitter<string>;
  @Input() disableFilter: boolean;
  @Input() filterPlaceholder: string;

  @Output() reload: EventEmitter<void>;

  @Input() columnFilters: string[][];
  @Input() columnFiltersDisplay: Array<(input: string) => string>;
  @Input() columnFilterValues: string[];
  @Output() columnFilterValuesChange: EventEmitter<string[]>;

  constructor() {
    this.pageIndex = 0;
    this.pageIndexChange = new EventEmitter<number>();

    this.pageCount = null;
    this.error = null;
    this.loading = false;

    this.filter = "";
    this.filterChange = new EventEmitter<string>();
    this.disableFilter = false;
    this.filterPlaceholder = "";

    this.reload = new EventEmitter<void>();

    this.columnFilters = [];
    this.columnFilterValues = [];
    this.columnFilterValuesChange = new EventEmitter<string[]>();
  }

  ngOnInit(): void {
  }

  public previousPage(): void {
    this.setPageIndex(this.pageIndex - 1);
  }

  public nextPage(): void {
    this.setPageIndex(this.pageIndex + 1);
  }

  public canPreviousPage(): boolean {
    return this.pageIndex > 0;
  }

  public canNextPage(): boolean {
    return this.pageIndex < (this.pageCount ?? 0) - 1;
  }

  public setPageIndex(pageIndex: number): void {
    this.pageIndex = pageIndex;
    this.pageIndexChange.emit(pageIndex);
    this.reload.emit();
  }

  public onSubmitFilter(): void {
    this.pageIndex = 0;
    this.pageIndexChange.emit(0);
    this.reload.emit();
  }
}
